import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Field, SubmitButton, FormMessage } from "@/components/Field";

export const ForgotForm = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    }
    setLoading(false);
  };

  return (
    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
      <Field label="Email" testId="forgot-email-input" type="email" placeholder="ton@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
      <FormMessage error={error} success={sent && "Si un compte existe avec cet email, tu vas recevoir un lien pour choisir un nouveau mot de passe."} />
      <SubmitButton testId="forgot-submit-button" loading={loading}>Recevoir le lien</SubmitButton>
      <p className="text-center">
        <button data-testid="back-to-login-link" type="button" onClick={onBack} className="link-bordeaux text-sm font-light">
          Retour à la connexion
        </button>
      </p>
    </form>
  );
};
